import React from 'react';
import PricingComponent from '../../../components/ui/PricingComponent/PricingComponent';

const PricePage = () => {
  return (
    <div className="price-page">
      <PricingComponent />
    </div>
  );
};

export default PricePage;
